angular.module('templatefarm', [
    'ui.router',
    'ngAnimate',
    "com.2fdevs.videogular",
    "com.2fdevs.videogular.plugins.controls",
    "com.2fdevs.videogular.plugins.buffering",
    'ngCookies',
    'ui.bootstrap',
    'ui.select',
    'cloudinary',
    'ngFileUpload',
    'duScroll',
    'mgcrea.ngStrap',
    'pascalprecht.translate',
    'angularResizable',
    'tf.models',
    'tf.translations',
    'tf.services',
    'tf.directives',
    'tf.controllers',
    'rzModule'
])

.config(['$urlRouterProvider','$stateProvider','$locationProvider', '$urlMatcherFactoryProvider',
        function($urlRouterProvider, $stateProvider, $locationProvider, $urlMatcherFactoryProvider ) {

    var DOCUMENTATION_PREFIX = window.location.href.indexOf('localhost') > -1 ? 'http://localhost:3000/#/'  : 'https://twizteddesign.github.io/template-farm-documentation/docs/#/';

    $locationProvider.html5Mode(true);
    $urlMatcherFactoryProvider.strictMode(false);

    $stateProvider
        .state('test', {
            url: '/test',
            templateUrl: 'views/partials/home.html'
        })
        .state('test2', {
            url: '/splitter',
            templateUrl: 'views/partials/splitter.html'
        })
        .state('test.list', {
            url: '/list',
            templateUrl: '/views/partials/home-list.html',
            controller: function($scope) {
                $scope.dogs = ['Bernese', 'Husky', 'Goldendoodle'];
            }
        })

        // nested list with just some random string data
        .state('test.paragraph', {
            url: '/paragraph',
            template: 'I could sure use a drink right now.'
        })


        // ABOUT PAGE AND MULTIPLE NAMED VIEWS =================================
        .state('about', {
            url: '/about',
            views: {

                // the main template will be placed here (relatively named)
                '': { templateUrl: '/views/partials/about.html' },

                // the child views will be defined here (absolutely named)
                'columnOne@about': { template: 'Look I am a column!' },

                // for column two, we'll define a separate controller
                'columnTwo@about': {
                    templateUrl: '/views/partials/home-list.html'
                }
            }
        })
        .state('root', {
            url: '/root',
            templateUrl: '/views/partials/root.html'
        })
        .state('dummy', {
            url: '/dummy',
            templateUrl: '/views/partials/dummy-farmer.html',
            controller: 'DummyFarmerController',
            data: {
                requireLogin : true
            },
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })
        .state('home', {
            url: '/home',
            //templateUrl: '/views/partials/landing-page.html',
            //controller: 'landingPageController'
            params : {'error': null, 'email' : null},
            templateUrl: '/views/partials/landing-page2.html',
            controller: 'LoginController',
            resolve: {
                preventDoubleLogin : function(AuthService){
                    AuthService.preventDoubleLogin();
                }
            }
        })
        .state('how', {
            url: '/how',
            params : {'error': null, 'email' : null},
            templateUrl: '/views/partials/how.html',
            controller: 'LoginController',
            resolve: {
                preventDoubleLogin : function(AuthService){
                    AuthService.preventDoubleLogin();
                }
            }
        })
        .state('login', {
            url: '/login',
            params : {'error': null, 'email' : null},
            templateUrl: '/views/partials/login.html',
            controller: 'LoginController',
            resolve: {
                preventDoubleLogin : function(AuthService){
                    AuthService.preventDoubleLogin();
                }
            }

        })
        .state('app-login',{
            url: '/app-login',
            templateUrl: '/views/partials/app-login.html',
            controller: 'AppLoginController',
            resolve: {
                preventDoubleLogin : function(AuthService){
                    AuthService.preventDoubleLogin();
                }
            }
        })
        .state('signup-dep', {
           url: '/signup1?tfref',
            params : {'error': null, 'email' : null},
            templateUrl: '/views/partials/signup.html',
            controller: 'SignupControllerDep',
            resolve: {
                preventDoubleLogin : function(AuthService){
                    AuthService.preventDoubleLogin();
                }
            }
        })
        .state('signup', {
            url: '/signup',
            params : {'error': null, 'email' : null, 'analytics_params':null},
            templateUrl: '/views/partials/signup/signup.html',
            resolve: {
                preventDoubleLogin : function(AuthService){
                    AuthService.preventDoubleLogin();
                }
            },
            abstract: true
        })
        .state('signup.email', {
            url: '?tfref',
            templateUrl: '/views/partials/signup/signup-email-password.html',
            controller: 'SignupController',
        })
        .state('signup.email-sep', {
            url: '/email1?tfref',
            templateUrl: '/views/partials/signup/signup-email.html',
            controller: 'SignupController',
        })
        .state('signup.password-sep', {
            url: '/password?tfref',
            templateUrl: '/views/partials/signup/signup-password.html',
            controller: 'SignupController',
        })
        .state('signup.account', {
            url: '/account?tfref',
            templateUrl: '/views/partials/signup/signup-details.html',
            controller: 'SignupController',
        })
        .state('contact', {
            url: '/contact',
            templateUrl: '/views/partials/contact.html',
            controller: 'LoginController'
        })
        .state('verify', {
            url: '/verify',
            templateUrl: '/views/partials/verify-email.html',
            controller: 'VerifyEmailController',
            resolve : {
                email : function(UserVerificationService){
                    return UserVerificationService.resolve();
                }
            }
        })
        .state('forgot', {
            url : '/forgot',
            templateUrl: '/views/partials/forgot-password.html',
            controller: 'ForgotPasswordController'
        })
        .state('reset', {
            url : '/reset/:token',
            templateUrl : '/views/partials/reset-password.html',
            controller: 'ResetPasswordController'
        })
        .state('verified', {
            url : '/verified/:token',
            resolve : {
                verification : function($stateParams, UserVerificationService){
                    return UserVerificationService.verify($stateParams.token);
                }
            }
        })
        .state('join', {
            url: '/join/:key',
            resolve : {
                verification : function($stateParams, UserVerificationService){
                    return UserVerificationService.join($stateParams.key);
                }
            }
        })
        .state('pricing',{
            url: '/gulp watch',
            // templateUrl:'/views/partials/pricing.html'
            templateUrl:'/views/partials/subscribe.html'
        })


        //.state('share', {
        //    url: '/share/:shareId',
        //    resolve : {
        //        share : function(ShareService, $stateParams){
        //            return ShareService.resolve($stateParams.shareId);
        //        }
        //    }
        //})
        .state('app',{
            url : '/',
            templateUrl : '/views/partials/app.html',
            abstract : true
        })
        .state('app.admin-zone', {
            url : 'admin-zone',
            templateUrl : '/views/partials/admin-zone.html',
            controller: 'AdminZoneController',
            resolve: {
                auth: function (AuthService) {
                    return AuthService.auth();
                },
            }
        })
        .state('app.farmers', {
            url : '',
            templateUrl : '/views/partials/farmers.html',
            controller: 'NavigationController',
            activetab: 'home',
            resolve : {

                auth : function(AuthService){
                    return AuthService.auth();
                },
                items : function(auth, FarmerService, FarmService,$q, $state){
                    var defer = $q.defer();
                    FarmService.getAssets().then(function(assets){
                        //var onlineFarmers = [];
                        //for(var i = 0 ; i < farmers.length ; i++){
                        //    //FarmerService.subscribe(farmers[i]);
                        //    if(farmers[i].farmer.online){
                        //        onlineFarmers.push(farmers[i]);
                        //    }
                        //}

                        defer.resolve(assets);
                    });
                    return defer.promise;

                }


            }
        })
        //Deprecated
        .state('app.subscribe-dep', {
            url: 'subscribe1',
            templateUrl: '/views/partials/subscribe.html',
            controller: 'subscriptionDepController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                },
                userInfo : function($q){
                    var defer = $q.defer();
                    defer.resolve({country : {code : 'US'}});
                    // UserInfo.getInfo(function(data) {
                    //     defer.resolve(data);
                    // }, function(err) {
                    //     defer.resolve({});
                    // });
                    return defer.promise;
                }
            }
        })

        .state('app.subscribe', {
            template :'<div>' +
                        '<div ui-view style="height:100%"></div>' +
                        '<fullscreen-loader>\n' +
                      '</div>',
            resolve : {
                // auth : function(AuthService){
                //     return AuthService.auth();
                // },
                userInfo : function($q){
                    var defer = $q.defer();
                    defer.resolve({country : {code : 'US'}});
                    return defer.promise;
                }
            },
            params:{'analytics_params':null},
            abstract : true
        })
        .state('app.subscribe.pricing', {
            url: 'pricing',
            templateUrl: '/views/partials/subscription/pricing.html',
            controller: 'SubscriptionController'
        })
        .state('app.subscribe.payment', {
            url: 'subscribe/payment?plan&period&c',
            templateUrl: '/views/partials/subscription/payment.html',
            controller: 'SubscriptionController'
        })
        .state('app.subscribe.processing-payment', {
            url: 'subscribe/processing?plan&period&c',
            templateUrl: '/views/partials/subscription/processing.html',
            controller: 'SubscriptionController'
        })
        .state('app.subscribe.thanks', {
            url: 'subscribe/thanks',
            templateUrl: '/views/partials/subscription/thanks.html',
            controller: 'SubscriptionController'
        })
        // .state('app.download',{
        //     url: 'download',
        //     templateUrl: '/views/partials/farmer-download.html',
        //     controller: 'FarmerDownloadController',
        //     resolve : {
        //         auth : function(AuthService){
        //             return AuthService.auth();
        //         }
        //     }
        // })
        .state('app.download',{
            url: 'download',
            templateUrl: '/views/partials/farmer-download-latest.html',
            controller: 'FarmerDownloadController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                },
                farmers : function(HttpService){
                    return new Promise(function(resolve, reject){
                        HttpService.get('farmer/downloads/latest').then(function(res) {
                            resolve(res.data);
                        }, reject);
                    });
                }
            }
        })
        .state('app.download-all',{
            url: 'download/all',
            templateUrl: '/views/partials/farmer-download-all.html',
            controller: 'FarmerDownloadController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                },
                farmers : function(HttpService){
                    return new Promise(function(resolve, reject){
                        HttpService.get('farmer/downloads').then(function(res) {
                            resolve(res.data);
                        }, reject);
                    });
                }
            }
        })
        .state('app.admin', {
            url: 'admin',
            templateUrl: '/views/partials/admin/dashboard.html',
            controller: 'AdminController',
            resolve : {
                admin : function($stateParams, UserVerificationService){
                    return UserVerificationService.resolveAdmin();
                }

            }
        })
        .state('app.tutorials', {
            url: 'tutorials',
            templateUrl: '/views/partials/tutorials.html',
            controller: function(HeaderService){
                HeaderService.setName("Tutorials");
            },
            resolve : {
                auth: function (AuthService) {
                    return AuthService.auth();
                }
            }
        })
        .state('app.documentation', {
            url: 'documentation',
            templateUrl: '/views/partials/documentation/doc-main.html',
            controller: ['$scope', '$state', 'HeaderService', function($scope, $state, HeaderService){
                HeaderService.setName("Documentation");
                if($state.current.name === 'app.documentation') {
                    $state.go('app.documentation.farmer', null, {location: 'replace'});
                }

                window.addEventListener('message', function(event) {
                    if (event.data.type === 'navigationChange') {
                        $scope.$apply(function() {
                            const path = event.data.path;
                            const id = path.indexOf("?id=") > -1 ? path.substring(path.indexOf("?id=") + 4) : null;
                            if (path.includes('ai_generator')) {
                                $state.go('app.documentation.ai_generator', { id });
                            }else if (path.includes('image_api')) {
                                $state.go('app.documentation.image_api', { id });
                            }
                            else if (path.includes('ae')) {
                                $state.go('app.documentation.ae', { id });
                            } else if (path.includes('api')) {
                                $state.go('app.documentation.api', { id });
                            } else if (path.includes('project-settings')) {
                                $state.go('app.documentation.projectSettings', { id });
                            } else if (path.includes('user-management')) {
                                $state.go('app.documentation.userManagement', { id });
                            } else {
                                $state.go('app.documentation.farmer', { id });
                            }
                        });
                    }
                });
            }],
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })
        // .state('app.documentation.api', {
        //     url: '/api',
        //     templateUrl: '/views/partials/documentation/doc-api.html'
        // })

        .state('app.documentation.api',{
            url : '/api?id',
            templateUrl : '/views/partials/documentation/doc-external.html',
            controller:function($scope, $sce, $stateParams) {
                var queryString = $stateParams.id? '?id=' + $stateParams.id : '';
                $scope.url = function () {
                    return $sce.trustAsResourceUrl(DOCUMENTATION_PREFIX  + 'api' + queryString);
                };
            }
        })
        .state('app.documentation.projectSettings',{
            url : '/projectSettings?id',
            templateUrl : '/views/partials/documentation/doc-external.html',
            controller:function($scope, $sce, $stateParams) {
                var queryString = $stateParams.id? '?id=' + $stateParams.id : '';
                $scope.url = function () {
                    return $sce.trustAsResourceUrl(DOCUMENTATION_PREFIX  + 'project-settings' + queryString);
                };
            }
        })
        .state('app.documentation.userManagement',{
            url : '/userManagement?id',
            templateUrl : '/views/partials/documentation/doc-external.html',
            controller:function($scope, $sce, $stateParams) {
                var queryString = $stateParams.id? '?id=' + $stateParams.id : '';
                $scope.url = function () {
                    return $sce.trustAsResourceUrl(DOCUMENTATION_PREFIX  + 'user-management' + queryString);
                };
            }
        })
        .state('app.documentation.image_api',{
            url : '/image_api?id',
            templateUrl : '/views/partials/documentation/doc-external.html',
            controller:function($scope, $sce, $stateParams) {
                var queryString = $stateParams.id? '?id=' + $stateParams.id : '';
                $scope.url = function () {
                    return $sce.trustAsResourceUrl(DOCUMENTATION_PREFIX  + 'image_api' + queryString);
                };
            }
        })
        .state('app.documentation.ai_generator',{
            url : '/ai_generator?id',
            templateUrl : '/views/partials/documentation/doc-external.html',
            controller:function($scope, $sce, $stateParams) {
                var queryString = $stateParams.id? '?id=' + $stateParams.id : '';
                $scope.url = function () {
                    return $sce.trustAsResourceUrl(DOCUMENTATION_PREFIX  + 'ai_generator' + queryString);
                };
            }
        })
        .state('app.documentation.getting-started', {
            url: '/getting-started',
            templateUrl: '/views/partials/documentation/doc-getting-started.html'
        })
        // .state('app.documentation.aereference', {
        //     url: '/aereference',
        //     templateUrl: '/views/partials/documentation/doc-aeRef.html'
        // })
        .state('app.documentation.ae',{
            url : '/ae?id',
            templateUrl : '/views/partials/documentation/doc-external.html',
            controller:function($scope, $sce, $stateParams) {
                var queryString = $stateParams.id? '?id=' + $stateParams.id : '';
                $scope.url = function () {
                    return $sce.trustAsResourceUrl(DOCUMENTATION_PREFIX  + 'ae' + queryString);
                };
            }
        })
        // .state('app.documentation.farmer', {
        //     url: '/farmer',
        //     templateUrl: '/views/partials/documentation/doc-farmer.html'
        // })
        .state('app.documentation.farmer',{
            url : '/farmer?id',
            templateUrl : '/views/partials/documentation/doc-external.html',
            controller:function($scope, $sce, $stateParams) {
                var queryString = $stateParams.id? '?id=' + $stateParams.id : '';
                $scope.url = function () {
                    return $sce.trustAsResourceUrl(DOCUMENTATION_PREFIX  + queryString);
                };
            }
        })
        .state('app.account',{
            url: 'account',
            templateUrl : '/views/partials/account/account-main.html',
            controller: ['$scope','$state','HeaderService', function($scope, $state, HeaderService){
                $scope.$state = $state;
                HeaderService.setName("Settings");
                if($state.current.name === 'app.account') {
                    $state.go('app.account.settings', null, {location: 'replace'});
                }
            }]
        })
        .state('app.account.settings',{
            url: '/settings',
            templateUrl : '/views/partials/account/account-user-settings.html',
            controller  : 'AccountUserSettingsController'

        })
        .state('app.account.farm',{
            url: '/settings/farm',
            allow: 'admin',
            templateUrl : '/views/partials/account/account-farm.html',
            controller : 'AccountFarmController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }

        })
        .state('app.account.users',{
            url: '/settings/users',
            allow: 'admin',
            templateUrl : '/views/partials/account/account-users.html',
            controller : 'AccountUsersController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })
        .state('app.account.groups',{
            url: '/settings/groups',
            allow: 'admin',
            templateUrl : '/views/partials/account/account-users.html',
            controller : 'AccountUsersController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })

        .state('app.account.farmers',{
            url: '/settings/farmers',
            allow: 'admin',
            templateUrl : '/views/partials/account/account-farmers.html',
            controller : 'AccountFarmersController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })
        .state('app.account.clusters',{
            url: '/settings/clusters',
            allow: 'admin',
            templateUrl : '/views/partials/account/account-farmers.html',
            controller : 'AccountFarmersController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })
        .state('app.account.sharing',{
            url: '/sharing',
            templateUrl : '/views/partials/account/sharing/account-sharing-users.html',
            controller : 'ShareManagerUsersController',
            resolve : {
                //data : function(ShareService){
                //    return ShareService.getSharedUsers();
                //}
            }
        })
        .state('app.account.sharing-users', {
            url: '/sharing/users/:folder',
            templateUrl : '/views/partials/account/sharing/account-sharing-users.html',
            controller : 'ShareManagerUsersController',
            resolve : {
                //data : function(ShareService, $stateParams){
                //    return ShareService.getSharedUsers($stateParams.folder);
                //}

            }
        })
        .state('app.account.sharing-folders', {
            url: '/sharing/folders/:user',
            templateUrl : '/views/partials/account/sharing/account-sharing-folders.html',
            controller : 'ShareManagerFoldersController',
            resolve : {
                //data : function(ShareService, $stateParams){
                //    return ShareService.getSharedFolders($stateParams.user);
                //}
            }
        })
        .state('app.account.billing',{
            url: '/settings/billing',
            allow: 'admin',
            templateUrl : '/views/partials/account/account-billing-info.html',
            controller : 'billingController',
            abstract : true
        })
        .state('app.account.billing.payment-methods',{
            url: '/payments',
            allow: 'admin',
            templateUrl : '/views/partials/account/account-billing-info',
            controller : 'billingController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })
        .state('app.account.billing.invoices',{
            url: '/invoices',
            allow: 'admin',
            templateUrl : '/views/partials/account/account-billing-info',
            controller : 'billingController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })
        .state('app.statistics',{
            url:'statistics',
            allow : 'manager',
            // plan : 200,
            paywall : true,
            templateUrl:'/views/partials/statistics/stat-main.html',
            controller: ['$state','HeaderService', function($state, HeaderService){
                HeaderService.setName("Statistics");
                if($state.current.name === 'app.statistics') {
                    $state.go('app.statistics.dashboard', null, {location: 'replace'});
                }
            }]
        })
        .state('app.cloudeditor',{
            url:'cloudeditor/:path',
            allow : 'editor',
            // plan : 200,
            paywall : true,
            templateUrl:'/views/partials/cloud-editor.html',
            controller: 'CloudEditorController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })
        .state('app.statistics.dashboard',{
            url: '/dashboard/:encoded?type&fromDate&toDate&unit&test&project',
            templateUrl : '/views/partials/statistics/stat-dashboard.html',
            controller: 'StatisticsController',
            allow : 'manager',
            paywall : true,
            // plan : 200,
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                },
                properties : function(auth, $stateParams, UrlEncodingService, $q){
                    var defer = $q.defer();
                    UrlEncodingService.decrypt($stateParams.encoded).then(function (decoded) {
                        defer.resolve(decoded);
                    }, function(){
                        defer.resolve({});
                    });
                    return defer.promise;
                }
            }
        })
        .state('app.statistics.project',{
            url: '/:path',
            plan : 200,
            templateUrl : '/views/partials/statistics/stat-dashboard.html',
            controller: 'StatisticsController',
            resolve: {
                project: function (ProjectService, $stateParams) {
                    return ProjectService.getProject($stateParams.path);
                }
            }
        })
        .state('app.history',{
            url: 'history?q&from_date&to_date&page&page_size',
            allow : 'editor',
            // plan  : 100,
            paywall : true,
            templateUrl:'/views/partials/history/history-main.html',
            controller : 'HistoryController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }

        })
        .state('app.schedule',{
            url: 'schedule',
            allow : 'editor',
            templateUrl:'/views/partials/schedule/schedule-main.html',
            controller : 'ScheduleController'
        })
        .state('privacy',{
            url:'/privacy',
            templateUrl:'/views/partials/legal/privacy.html'
        })
        .state('eula',{
            url:'/eula',
            templateUrl:'/views/partials/legal/eula.html'
        })
        .state('app.taskManager',{
            url:'taskmanager',
            templateUrl:'/views/partials/taskManager.html',
            controller:'TaskManagerController',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                }
            }
        })
        .state('app.folder', {
            url: ':path',
            templateUrl: '/views/partials/folders.html',
            controller: 'NavigationController',
            activetab: 'home',
            resolve : {
                auth : function(AuthService){
                    return AuthService.auth();
                },
                items : ['auth', 'NavigationService', '$stateParams', 'DemoFarmerService',
                    function(auth, NavigationService, $stateParams, DemoFarmerService){
                    if($stateParams.path === 'demo-farmer'){
                        $stateParams.demo = true;
                        return DemoFarmerService.folderPromise;
                    }
                    return NavigationService.getContent($stateParams.path);
                }]

            }

        })
        .state('app.project', {
            url: 'project/:path',
            controller: 'ProjectController',
            activetab: 'home',
            templateUrl: function ($stateParams) { // Can not inject dependencies
                return '/views/partials/' + (window.isMobile ? "project-mobile2" : "project-desktop") + '.html';
            },
            resolve: {
                auth: function (AuthService) {
                    return AuthService.auth();
                },
                project: ['ProjectService', '$stateParams', 'auth',function (ProjectService, $stateParams, auth) {
                    if($stateParams.path === 'demo-project'){
                        $stateParams.demo = true;
                        return ProjectService.getDemoProject();
                    }
                    return ProjectService.getProject($stateParams.path);
                }]

            }
        })
        ;

        $urlRouterProvider.otherwise('/home');

    }])

    .config(['cloudinaryProvider', function (cloudinaryProvider) {
        cloudinaryProvider
            .set("cloud_name", "twizted-design")
            .set("upload_preset", "u1e1gclb");
    }])
    .config(['$httpProvider', function($httpProvider) {
        $httpProvider.interceptors.push("HttpInterceptorService");
    }])
    .config(['$translateProvider','LANG_EN', function($translateProvider, LANG_EN) {
        $translateProvider.translations('en', LANG_EN);
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('escape');
    }])

    .run(['$rootScope', function($rootScope) {
        var devKey = 'pk_test_R1kjXorB7ihfoWy5r1Y3KXBb';
        var prodKey = 'pk_live_bJnf3bLEWfCthZNknxp7ZzDt';
        var productionHost = 'templatefarm.io';
        var key = window.location.hostname.toLowerCase().search(productionHost) < 0? devKey : prodKey;
        if(window.Stripe){
            $rootScope.stripe = Stripe(key);
        }
    }])


    .run(['AuthService', function(AuthService){
        AuthService.resolve();
    }])
    .run([function () {
        FastClick.attach(document.body);
        var clipboard = new Clipboard('.clipboard');

        clipboard.on('success', function(e) {
            console.log('Copied to clipboard');
        });
    }])
    .run(['$rootScope', 'rbac', '$state', 'Session', function($rootScope, rbac, $state, Session){
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
            if(toState.allow){
                Session.whenReady().then(function(){
                    rbac.allow(toState.allow).then(function(){

                    }, function(){
                        $state.go('app.farmers');
                    });
                });
            }
            if(toState.paywall){
                Session.whenReady().then(function(){
                    var plan = Session.farm.plan;
                    if(plan.code === 0){
                        // app.subscribe.pricing({analytics_params:{initiator:'upgrade - header'}})
                        $state.go('app.subscribe.pricing');
                    }
                });
            }
            if(toState.plan){
                Session.whenReady().then(function(){
                    if(Session.farm.plan.code < toState.plan){
                        $state.go('app.farmers');
                    }
                });
            }
        });

        $rootScope.loader = {};
        $rootScope.$on('working', function(e, data){
            if(_.isBoolean(data)){
                if(data) {$rootScope.loader.overlay = true; }
                $rootScope.loader.loading = data;
            }
            else if (_.isObject(data)){
                $rootScope.loader.overlay = data.overlay;
                $rootScope.loader.loading = true;
            }
        });
        $rootScope.loader = function(options){
            $rootScope.$broadcast('working', options);
        };
    }])
    .run(['$rootScope','AuthAlertService','NotificationService','$location', 'MixpanelService','StorageService', 'TaskService','Session',
        function($rootScope, AuthAlertService, NotificationService, $location, MixpanelService, StorageService, TaskService, Session){
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
            NotificationService.clear();
        });
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams,fromState, fromParams) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            if(_.includes(['app.farmers','app.folder','app.project'], toState.name)){
                StorageService.store('lastNavigationState', {name : toState.name, params: toParams});
            }
            try {
                //Send analytics event on new page
                var eventProps = _.extend({},
                    {page: toState.name, 'from page': fromState.name === '' ? undefined : fromState.name},
                    toParams.analytics_params);
                var eventName = 'page view';

                MixpanelService.sendEvent(eventName, eventProps);
                MixpanelService.sendDevEvent(eventName, eventProps);
            }catch (e) {
                console.log('Failed to send analytics event ', e);
            }
        });
        $rootScope.$on('tf-alert', function(event,data){
            AuthAlertService.alert(data.message, data.type || "success", data.duration || 10);
        });
        $rootScope.$on('tf-popup', function (event, data) {
            NotificationService.popup(data.type? data.type : 'info-popup', {content : data.message, session : Session});
        });

        window.mobilecheck = function () {
            var check = false;
            (function (a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };

        if($location.search().device === 'mobile'){
            $rootScope.isMobile = window.isMobile = true;
        } else if ($location.search().device === 'desktop'){
            $rootScope.isMobile = window.isMobile = false;
        } else {
            $rootScope.isMobile = mobilecheck();
            window.isMobile = mobilecheck();
        }

        $rootScope.isPanel = $location.search().panel==='PPRO';

        Session.whenReady().then(function initTasks (){
            TaskService.initTasks();
        });

    }])

    .controller(['$scope','AuthService',function($scope, AuthService){
        $scope.isLoggedIn = AuthService.isAuthenticated;
    }]);

angular.module('tf.models',[]);
angular.module('tf.translations',[]);
angular.module('tf.controllers',[]);
angular.module('tf.services', []);
angular.module('tf.directives', []);
